const allowedFormats = [
  // Image Formats
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/tiff",
  "image/svg+xml",
  "image/vnd.microsoft.icon",

  // Video Formats
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video/x-msvideo",
  "video/mpeg",
  "video/3gpp",
  "video/x-flv",
  "video/quicktime",

  // Audio Formats
  "audio/mpeg",
  "audio/wav",
  "audio/ogg",
  "audio/webm",
  "audio/aac",
  "audio/flac",
  "audio/midi",
  "audio/x-matroska",
  "audio/x-wav",

  // Document Formats
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "text/csv",
  "application/rtf",
  "application/x-abiword",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.oasis.opendocument.spreadsheet",

  // Compressed/Archive Formats
  "application/zip",
  "application/x-rar-compressed",
  "application/x-7z-compressed",
  "application/gzip",
  "application/x-tar",

  // Application Formats
  "application/json",
  "application/javascript",
  "application/xml",
  "application/x-www-form-urlencoded",
  "application/x-shockwave-flash",
  "application/x-msdownload",

  // Web Formats
  "text/html",
  "text/css",
  "text/javascript",

  // Font Formats
  "font/woff",
  "font/woff2",
  "application/x-font-ttf",
  "application/x-font-opentype",

  // Other Formats
  "application/octet-stream",
  "application/vnd.apple.installer+xml",
  "application/x-dvi",
  "application/x-httpd-php",
  "application/vnd.mozilla.xul+xml",
  "application/vnd.ms-access",
];
module.exports = {
  allowedFormats,
};
